export default __webpack_public_path__ + "static/media/Landing_HomePC.2f34074f.jpg";